"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JwtStrategyProvider", {
    enumerable: true,
    get: function() {
        return JwtStrategyProvider;
    }
});
const _passportjwt = require("passport-jwt");
const _metaservice = require("~/meta/meta.service");
const _usersservice = require("~/services/users/users.service");
const _jwtstrategy = require("~/strategies/jwt.strategy");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const JwtStrategyProvider = {
    provide: _jwtstrategy.JwtStrategy,
    useFactory: async (usersService, metaService)=>{
        const config = metaService.config;
        await _Noco.default.initJwt();
        const options = _extends({
            // ignoreExpiration: false,
            jwtFromRequest: _passportjwt.ExtractJwt.fromHeader('xc-auth'),
            // expiresIn: '10h',
            passReqToCallback: true,
            secretOrKey: config.auth.jwt.secret
        }, config.auth.jwt.options);
        return new _jwtstrategy.JwtStrategy(options, usersService);
    },
    inject: [
        _usersservice.UsersService,
        _metaservice.MetaService
    ]
};
